module.exports = __webpack_public_path__ + "media/images/vanguard-assessments-logo@2x-451b850f1c1ee9b20e40c695068c5528.webp";